// extracted by mini-css-extract-plugin
module.exports = {"navItem":"navigationItem_navItem__1f3fo","active":"navigationItem_active__udzcX"};